import React, { useEffect, useState } from "react";
import Frame from "components/shared/Frame";
import { IStep } from "types";
import Button from "components/shared/Button";
import { Form, Formik, FormikHelpers } from "formik";
import FormField from "components/shared/FormField";
import * as Yup from "yup";

import loader from "assets/loader.gif";

import { USER_ROLES } from "utils/UIProvider";

import { toast } from "react-toastify";

import axios from "axios";
import { api } from "./../../../../constants";

const RegisterStep: React.FC<IStep> = ({
  onBack,
  onNext,

  step,
}: any) => {
  const [button, setButton] = useState<boolean>(false);

  const init = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    username: "",
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, "Your first name should be atleast 2 characters long")
      .required("Your first name is required"),
    lastName: Yup.string()
      .min(2, "Your last name should be atleast 2 characters long")
      .required("Your last name is required"),

    password: Yup.string()
      .min(6, "Password should minimum 6 characters long")
      .matches(/[0-9a-zA-Z]/, "Password can only contain letters and numbers")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Password confirmation is required"),
  });

  const handleFormSubmission = async (
    data: typeof init,
    actions: FormikHelpers<typeof init>
  ) => {
    actions.setSubmitting(true);
    const inputData = { ...data };

    const postData = {
      channel: "indianu",
      cmd: "ModHandle.signUpIndianPortal",
      password: inputData?.password,
      user: {
        username: inputData?.username,
        f_name: inputData?.firstName,
        l_name: inputData?.lastName,
        phone_number: "",
        role: USER_ROLES.STUDENT,
        password: inputData?.password,
      },
    };

    const response = await axios.post(api, postData);

    actions.setSubmitting(false);

    if (response.data?.error) {
      return toast.error(response.data.error);
    } else {
      toast.success("Student account created successfully!");
      onNext({ user: response.data?.user_info });
    }
  };

  return (
    <Frame
      step={step}
      title="Let's create your student account"
      onBackButtonClick={onBack}
    >
      <div id="recaptcha-container"></div>
      <Formik
        initialValues={init}
        validationSchema={validationSchema}
        onSubmit={handleFormSubmission}
      >
        {({ handleSubmit, isSubmitting, errors, touched }) => (
          <Form
            onKeyDown={(e) => {
              if (e.key == "Enter") {
                handleSubmit();
              }
            }}
          >
            {!isSubmitting && (
              <div>
                <div className="row__1">
                  <div className="first">
                    <FormField name="firstName" placeholder="First Name" />
                  </div>
                  <div className="second">
                    <FormField name="lastName" placeholder="Last Name" />
                  </div>
                </div>
                <div className="row__1">
                  <div className="col-12">
                    <FormField name="username" placeholder="User Name" />
                  </div>
                </div>

                <div className="row">
                  <div className="">
                    <FormField
                      type="password"
                      name="password"
                      placeholder="Password"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="">
                    <FormField
                      type="password"
                      name="confirmPassword"
                      placeholder="Confirm Password"
                    />
                  </div>
                </div>

                {(errors as any)?.general && (
                  <div className="error">
                    <p>{(errors as any)?.general}</p>
                  </div>
                )}
                <div className="btn__submit">
                  <div className="row__1 m-auto">
                    <div className="col-12 m-auto">
                      <Button
                        value="Submit"
                        onClick={handleSubmit}
                        disabled={button}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isSubmitting && (
              <img
                src={loader}
                style={{ width: 300, margin: "auto" }}
                alt="loader"
              />
            )}
          </Form>
        )}
      </Formik>
    </Frame>
  );
};

export default RegisterStep;
